import { Edit, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Button, Form, Input, InputNumber, Switch } from "antd";
import { useState } from "react";
import { IconDisplay } from "../../components/IconDisplay";
import { ImageUpload } from "../../components/ImageUpload";

export function CardTemplateEdit() {
  const [showDisplayUpload, setShowDisplayUpload] = useState(false);
  const [showSvgUpload, setShowSvgUpload] = useState(false);

  const { formProps, saveButtonProps, query, formLoading } = useForm<
    any,
    HttpError,
    any
  >({
    resource: "card-template",
    successNotification: (data) => ({
      message: data?.data.message,
      type: "success",
    }),
    action: "edit",
  });

  const tpl = query?.data?.data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="card-template"
      mutationMode="optimistic"
      title="Edit card template"
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Title"
          name={["title"]}
          initialValue={tpl?.title}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name={["description"]}
          initialValue={tpl?.description}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Coach line"
          name={["coachLine"]}
          initialValue={tpl?.coachLine}
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item
          label="Primary colour"
          name={["primaryColor"]}
          initialValue={tpl?.primaryColor}
          rules={[
            { required: true },
            {
              pattern: /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/,
              message: "Hex colour, e.g. #C6F24E",
            },
          ]}
        >
          <Input placeholder="#C6F24E" />
        </Form.Item>

        <Form.Item
          label="Display image (PNG)"
          name="displayImageID"
          initialValue={tpl?.displayImageFileUploadId}
        >
          {!showDisplayUpload ? (
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <IconDisplay
                iconURL={tpl?.displayImageURL}
                width={64}
                height={64}
                borderRadius="8px"
              />
              <Button onClick={() => setShowDisplayUpload(true)}>
                Change Image
              </Button>
            </div>
          ) : (
            <ImageUpload uploadType="CARD_TEMPLATE" accept="image/*" />
          )}
        </Form.Item>

        <Form.Item
          label="Fillable SVG"
          name="fillableSvgID"
          initialValue={tpl?.fillableSvgFileUploadId}
          rules={[{ required: true, message: "A fillable SVG is required" }]}
        >
          {!showSvgUpload ? (
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <IconDisplay
                iconURL={tpl?.fillableSvgURL}
                width={64}
                height={64}
                borderRadius="8px"
              />
              <Button onClick={() => setShowSvgUpload(true)}>Change SVG</Button>
            </div>
          ) : (
            <ImageUpload
              uploadType="CARD_TEMPLATE"
              accept="image/svg+xml,.svg"
            />
          )}
        </Form.Item>

        <Form.Item
          label="XP threshold"
          name={["xpThreshold"]}
          initialValue={tpl?.xpThreshold ?? 0}
          tooltip="Minimum lifetime training XP required to unlock this card level."
        >
          <InputNumber min={0} step={250} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Priority"
          name={["priority"]}
          initialValue={tpl?.priority ?? 0}
          tooltip="Deck order — lower shows first (0 = leftmost)."
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Active"
          name={["isActive"]}
          valuePropName="checked"
          initialValue={tpl?.isActive}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
}
